export { default } from "./ContentDisplayHeaderMedia";
